import { Box } from "@mui/material";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { SecurityPipelineGithubPageHeader } from "../components/SecurityPipelineGithubPageHeader/SecurityPipelineGithubPageHeader";
import { setDocumentTitle } from "~/lib/commonUtils";
import { useSecurityPipelineIntegrations } from "~/pages/integrations/security-pipeline/hooks/useSecurityPipelineIntegrations";
import { LoadingPage } from "~/components/loading";
import { SecurityPipelineGithubSetup } from "../components/SecurityPipelineGithubSetup/SecurityPipelineGithubPageTabSetup";
import { SECURITY_PIPELINE_DISPLAY_NAME } from "../../constants";

export interface SecurityPipelineGithubPageProps {
  scope: SpaceScope | OrganizationScope;
}

export const SecurityPipelineGithubOrgPage = ({
  scope,
}: SecurityPipelineGithubPageProps) => {
  const { integration, isLoading, canCreateIntegration } =
    useSecurityPipelineIntegrations();
  const integrationId = integration?.mrn.split("/").pop();

  setDocumentTitle([
    integration?.name,
    `Github ${SECURITY_PIPELINE_DISPLAY_NAME}`,
    "Integrations",
    scope.name,
  ]);

  if (isLoading) {
    return <LoadingPage what="Loading Security Pipeline" />;
  }

  return (
    <Box>
      <SecurityPipelineGithubPageHeader
        integrationId={integrationId}
        integrationStatus={integration?.status}
        scope={scope}
        errorMsg={null}
        integrationName="Security Pipeline"
        lastUpdated={integration?.lastModified}
      />
      <SecurityPipelineGithubSetup
        scope={scope}
        integrationId={integrationId || ""}
        canCreateIntegration={canCreateIntegration}
      />
    </Box>
  );
};
